import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class AchievementsBar extends React.Component {
  render() {
    let data = this.props.data;
    
    let projectObj = { ok: 0, ng: 0, assign: 0, complete: 0 };
    
    // プロジェクトごとの処理
    let projects = this.props.projects;
    projects.map((d, key) => {
      if( projectObj[d.project_mode] != undefined ) projectObj[d.project_mode]++;
      if( d.project_complete == true ) projectObj.complete += 1;
    });
    
    // 成功率の計算
    let assign_per = ((projectObj.ok / (projectObj.ok + projectObj.ng)) * 100);
    if( isNaN(assign_per) || assign_per == 'Infinity' ) assign_per = 0;
    
    let entry_per = ((projectObj.assign / projectObj.ok) * 100);
    if( isNaN(entry_per) || entry_per == 'Infinity' ) entry_per = 0;
    
    let complete_per = ((projectObj.complete / (projectObj.ok + projectObj.complete)) * 100);
    if( isNaN(complete_per) || complete_per == 'Infinity' ) complete_per = 0;
    
    let assign_count = (projectObj.assign - projectObj.ok);
    
    // アサインパーセンテージの作成
    let achievements_bar = [];
    if( assign_count  > 0 ) achievements_bar.push({ id: 'assign', name: 'アサイン依頼', count: assign_count });
    if( projectObj.ok > 0 ) achievements_bar.push({ id: 'ok',     name: 'アサインOK',   count: projectObj.ok });
    if( projectObj.ng > 0 ) achievements_bar.push({ id: 'ng',     name: 'アサインNG',   count: projectObj.ng });
    
    let achievements_count = 0;
    achievements_bar.map((d) => { achievements_count += d.count; });
    
    return (
      <div className="achievements-bar">
        <h2>アサイン実績</h2>
        <h5>項目のバーをクリックすることでプロジェクトの詳細を確認できます</h5>
        
        <div className="bar">
          { achievements_bar.map((d, key) => {
            let per = Math.round((d.count / achievements_count) * 100);
            return (
              <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>{d.name}の詳細を表示します</Tooltip>}>
                <p className={d.id} style={{ width: (per +'%') }} onClick={this.props.change_ev.bind(this, d.id)}>{per}<span>%</span></p>
              </OverlayTrigger>
            );
          })}
        </div>
        
        <div className="columns">
          { achievements_bar.map((d, key) => {
            return (
              <p key={key} className={d.id}>■{d.name} <span>({d.count}回)</span></p>
            );
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default AchievementsBar;